import { REAL_TIME } from './realTimeConst';

export const isRealTimeReport = () => {
    // TODO: https://jira.taboola.com/browse/DEV-120750
    return new URL(window.location.href).searchParams.get('datePreset') === REAL_TIME;
};
